import { Button } from '@chakra-ui/react'
import { LuArrowLeft } from 'react-icons/lu'
import { useNavigate } from 'react-router'

type Props = {
  to?: string
  color?: string
  disableHover?: boolean
}

const BackButton = ({ to, color, disableHover }: Props) => {
  const navigate = useNavigate()

  return (
    <Button
      variant="ghost"
      size="sm"
      color={color}
      _hover={disableHover ? { bg: 'transparent' } : undefined}
      onClick={() => (to ? navigate(to) : navigate(-1))}
    >
      <LuArrowLeft />
      Voltar
    </Button>
  )
}

export default BackButton
